module.exports = __webpack_public_path__ + "img/Twist32.140a317f.jpg";